import UserLocation from "../../../model/userLocation/UserLocation";

/**
 * Fetch user locations successful action.
 */
export const USER_LOCATIONS_FETCHED = "USER_LOCATIONS_FETCHED";
export type USER_LOCATIONS_FETCHED = { userLocations: Array<UserLocation> }
